<main>
    <div class="container dark-grey-text mt-5">
        <b-overlay :show="isLoading" rounded="sm">
            <div class="row wow fadeIn">
                <div class="col-md-3 mb-4">
                    <img v-if='(product.img)' class="img-fluid img-thumbnail" :src="product.img" :alt="product.text" />
                </div>
                <!--product details-->
                <div class="col-md-9 mb-4">
                    <h2>{{product.text}}</h2>
                    <div class="p-1">
                        <form id="form" action="post">
                            <!--phone number picker-->
                            <div class="form-group">
                                <p class="font-weight-bold">Receiver Number</p>
                                <vue-phone-number-input id="Umbai" v-model="receiverNumber"
                                    :default-country-code="product.isoCountry.toUpperCase()" no-example required
                                    size="lg" maxlength="12" @update="ValidateReceiverNumber" />
                                <div><span class="text-warning">{{valideReceiverNumberMessage}}</span></div>
                            </div>
                            <div v-if="product.senderNumberRequired" class="form-group">
                                <p class="font-weight-bold">Sender Number</p>
                                <vue-phone-number-input id="Umbai" v-model="senderNumber" :default-country-code="originator.toUpperCase()"
                                    required size="lg" no-example maxlength="12" @update="ValidateSenderNumber" />
                                <div><span class="text-warning">{{valideSenderNumberMessage}}</span></div>
                            </div>

                            <!--phone number picker-->
                            <!--price selector-->
                            <div class="form-group">
                                <p class="font-weight-bold">Amount</p>
                                <select v-model="selectedProduct" required
                                    class="form-control">
                                    <option v-for="(value, name, index) in priceList.productList" :value="value"
                                        :key="name">

                                    <span v-if="value.description">
                                        {{value.description}}
                                    </span>

                                    <span v-else-if="product.displaySalesCurrency">
                                        {{product.isoSalesCurrency}}{{ value.salesCurrencyAmount }} (
                                        {{product.isoCurrency}}{{ value.totalAmount }})
                                    </span>

                                    <span v-else>
                                        {{product.isoCurrency}}{{ value.totalAmount }}
                                    </span>

                                    </option>
                                </select>
                            </div>
                            <!--price selector-->
                            <br />
                            <base-button class="btn-3" type="primary" @click='CheckOutProduct' icon="ni ni-credit-card">
                                Proceed to payment
                            </base-button>
                        </form>
                    </div>
                </div>
                <!--product details-->
            </div>
        </b-overlay>
    </div>
</main>